import React from "react";
import { Box } from "@material-ui/core";
import clsx from "clsx";

import useStyles from "./NotificationStack.styles";

interface NotificationProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const Notification = ({ children, className, style }: NotificationProps): JSX.Element => {
  const classes = useStyles();
  return (
    <Box className={clsx(classes.notification, className)} style={style}>
      {children}
    </Box>
  );
};

export default Notification;
